<template>
    <div id="index">
        <div class="visible-xs">
            <div class="head_div flex_between">
                <i @click.stop="goLogin">
                    <img src="@/assets/img/esc_fan.png" alt="">
                </i>
                <!-- <span @click.stop="login">跳过直接登录</span> -->
            </div>
            <div class="logo_div">
                <h4 class="title">基本信息</h4>
                <div class="user_num" :class='{"value":nickname !== ""}'>
                    <input type="text" @focus="is_keyboard = true" @blur="is_keyboard = false" v-model="nickname"
                        placeholder="昵称">
                </div>
                <div class="user_num password_li" :class='{"value": email !== ""}'>
                    <input type="text" @focus="is_keyboard = true" @blur="is_keyboard = false" v-model="email"
                        placeholder="邮箱">
                </div>
                <div class="user_num password_li" :class='{"value":name !== ""}'>
                    <input type="text" @focus="is_keyboard = true" @blur="is_keyboard = false" v-model="name"
                        placeholder="真实姓名">
                </div>
                <div class="user_num password_li" :class='{"value":workName !== ""}'>
                    <input type="text" @focus="is_keyboard = true" @blur="is_keyboard = false" v-model="workName"
                        placeholder="单位名称">
                </div>
                <div class="user_num password_li" :class='{"value":professor !== ""}'>
                    <input type="text" @focus="is_keyboard = true" @blur="is_keyboard = false" v-model='professor'
                        placeholder="职称">
                </div>
                <div class="user_num password_li" :class='{"value":office !== ""}'>
                    <input type="text" @focus="is_keyboard = true" @blur="is_keyboard = false" v-model='office'
                        placeholder="科室">
                </div>
                <div class="user_num password_li"  :class='{"value":cert !== ""}'>
                    <span class="li_title">执医证:</span>
                        <el-upload
                                class="avatar-uploader"
                                :action="URL + 'upload'"
                                :show-file-list="false"
                                :on-success="handleAvatarSuccess"
                                :before-upload="handleAvatarPreview">
                                <img v-if="cert" :src="cert" class="avatar">
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </div>
                <div class="user_num password_li" :class='{"value":address !== ""}'>
                    <input type="text" @focus="is_keyboard = true" @blur="is_keyboard = false" v-model='address'
                        placeholder="邮寄地址(选填)">
                </div>
                <div class="flex_center complete">
                    我们将不定期为您送上《麻醉·眼界》杂志哦！
                </div>
                <button class="login" @click="login">获取验证码</button>
                
            </div>
        </div>
    </div>
</template>

<script>

    import "@/assets/js/swiper.animate1.0.3.min.js";
    import "@/assets/css/animate.min.css";
    import "@/assets/css/video-js.min.css";

    export default {
        name: "index",
        data() {
            return {
                IMG_URL: this.$IMG_URL,
                is_keyboard: false,//是否打开键盘
                phone: '',//手机
                cert:'',
                URL:this.$URL,
                nickname: '',//昵称
                name: '',//真实姓名
                workName: '',//工作单位
                professor: '',//职称
                office: '',//科室
                email: '',//邮箱
                address: '',//邮寄地址
            };
        },
        computed: {},
        components: {

        },
        watch: {

        },
        methods: {
             handleAvatarPreview () {//开始上传
                layer.open({
                    type: 2
                    , content: '上传中'
                });
                },
                handleAvatarSuccess (res, file) {
                layer.closeAll();
                layer.open({
                    content: "上传完成",
                    time: true,
                    skin: "msg"
                });
                this.cert = res.data;
                },
            goLogin() {//返回上一页
                this.$router.go(-1)
            },
            validation() {//验证信息
                if (this.nickname == '' || !this.nickname) {
                    layer.open({
                        content: "请填写昵称",
                        time: true,
                        skin: "msg"
                    });
                    return false;
                }
                if (this.email == '' || !this.email) {
                    layer.open({
                        content: "请填写邮箱",
                        time: true,
                        skin: "msg"
                    });
                    return false;
                }
                if (this.name == '' || !this.name) {
                    layer.open({
                        content: "请填写真实姓名",
                        time: true,
                        skin: "msg"
                    });
                    return false;
                }
                if (this.workName == '' || !this.workName) {
                    layer.open({
                        content: "请填写单位名称",
                        time: true,
                        skin: "msg"
                    });
                    return false;
                }
                if (this.professor == '' || !this.professor) {
                    layer.open({
                        content: "请填写职称",
                        time: true,
                        skin: "msg"
                    });
                    return false;
                }
                if (this.office == '' || !this.office) {
                    layer.open({
                        content: "请填写科室",
                        time: true,
                        skin: "msg"
                    });
                    return false;
                }
                 if (this.cert == '' || !this.cert) {
                    layer.open({
                        content: "请上传执医证",
                        time: true,
                        skin: "msg"
                    });
                    return false;
                }
                return true
            },
            
            login() {
                if (!this.validation()) {
                    return false;
                }
                let that = this;
                let arr = {
                    phone:this.phone,
                    username: this.nickname,
                    realname: this.name,
                    company: this.workName,
                    professor: this.professor,
                    office:this.office,
                    email:this.email,
                    cert:this.cert
                }
                if(this.address){
                    arr.address = this.office;
                }
                this.$store.commit('setBasic',arr)
                // this.$post('user_modify', {
                //     mobile: this.phone,
                //     username: this.nickname,
                //     realname: this.name,
                //     company: this.workName,
                //     address: this.workAddress,
                // }).then(res => {
                //     layer.open({
                //         content: "保存成功！",
                //         time: true,
                //         skin: "msg"
                //     });
                //     setTimeout(() => {
                //         that.$router.replace("/m_password");
                //     }, 1000)

                // }).catch(res => {
                //      
                //     layer.open({
                //         content: res.message,
                //         time: true,
                //         skin: "msg"
                //     });
                // })

                this.$router.push({path:'./m_code',query:{ type:2}});
            },
            // 判断完毕后加载样式
            setActiveStyleSheet(filename) {
                document.write("<link href=" + filename + " rel=stylesheet>");
            },

        },
        mounted() {
            console.log(this.$store.state.basic,'basic');
            let that = this;
            this.phone = this.$store.state.phone;
            this.nickname = this.$store.state.basic.username;
            this.name = this.$store.state.basic.realname;
            this.workName = this.$store.state.basic.company;
            this.professor = this.$store.state.basic.professor;
            this.office = this.$store.state.basic.office;
            this.cert = this.$store.state.basic.cert;
            this.email = this.$store.state.basic.email;
            this.address = this.$store.state.basic.address;
            this.getShare();
            if (this._isMobile()) {
                // alert("手机端");
                //   this.$router.replace('/m_index');
            } else {
                // alert("pc端");
                this.$router.replace("/");
            }


            // window.onload = function () {
            //     var w = document.body.clientWidth; //获取屏幕宽度
            //     // 这里*100 是为了取整数
            //     var x = parseInt((w * 100) / 375 * 10) / 10; //获取任意屏幕上的根节点字体大小
            //     document.getElementsByTagName('html')[0].style.fontSize = x + 'px';
            //     //监听屏幕宽度变化
            //     window.onresize = function () {
            //         var w = document.body.clientWidth; //获取屏幕宽度
            //         var x = parseInt((w * 100) / 375 * 10) / 10;; //获取任意屏幕上的根节点字体大小
            //         document.getElementsByTagName('html')[0].style.fontSize = x + 'px';
            //     }
            // }
        }
    };
</script>

<style scoped>
    html,
    body {
        max-width: 100vw;
    }
    .password_li .li_title {
        text-align: left;
        width: 9rem;
        white-space: nowrap;
        font-size: 1.4rem;
        color: #8f8383;
        height: 2.8rem;
        line-height: 2.8rem;
    }
    .avatar-uploader .el-upload {
        border: 1px dashed #dfdfdf;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        border: 1px solid #dfdfdf;
        color: #dfdfdf;
        width: 150px;
        height: 150px;
        line-height: 150px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
    .visible-xs {
        width: 100vw;
        overflow: hidden;
        padding-top: 0rem;
        padding: 1.6rem 2.4rem;
    }

    .head_div>span {
        font-size: 1.3rem;
        color: #333;
    }

    .head_div>i {
        width: 1.8rem;
    }

    .logo_div {
        position: fixed;
        top: 8vh;
        left: 50%;
        transform: translateX(-50%);
        width: calc(100vw - 4rem);
    }

    .title {
        margin-top: 5rem;
        font-size: 2rem;
        color: 333;
        font-weight: bold;
    }

    .user_num {
        border-bottom: .05rem solid #EFEFEF;
        margin-top: 5.8rem;
    }

    .user_num>input {
        width: 100%;
        height: 4rem;
        font-size: 1.3rem;
        line-height: 4rem;
    }

    .user_num.value {
        border-color: #F24D5B;
    }

    .password_li {
        margin-top: 2.7rem;
    }

    .forget_div {
        margin-top: 1rem;
    }

    .forget_div .forget {
        font-size: 1.2rem;
        color: #666;
    }

    .login {
        width: 100%;
        margin-top: 6vh;
        height: 4.5rem;
        border-radius: 2.2rem;
        background: #F24D5B;
        color: #fff;
        border: 0;
        font-size: 1.8rem;
        box-shadow: 0 0 2.7rem rgba(241, 77, 91, 0.3);
    }

    .prompt {
        margin-top: 3.7rem;
        font-size: 1.3rem;
        color: #999999
    }

    .prompt>span {
        color: #F14D5B;
        margin-left: .4rem;
    }

    .wx_logo {
        position: fixed;
        bottom: 3rem;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
    }

    .wx_logo .wx_text {
        font-size: 1.2rem;
        color: #BABFC0;
        position: relative;
    }

    .wx_logo .wx_text::after {
        content: '';
        position: absolute;
        left: -10rem;
        top: 50%;
        transform: translateY(-50%);
        width: 8.8rem;
        height: .05rem;
        background: #DFDFDF;
    }

    .wx_logo .wx_text::before {
        content: '';
        position: absolute;
        right: -10rem;
        top: 50%;
        transform: translateY(50%);
        width: 8.8rem;
        height: .05rem;
        background: #DFDFDF;
    }

    .wx_logo>i {
        width: 4rem;
        margin: 1.7rem auto 0 auto;

    }

    .visible-xs {
        width: 100vw;
        overflow: hidden;
        padding-top: 0rem;
        padding: 1.6rem 2.4rem 15rem 2.4rem;
        min-height: calc(100vh - 16.6rem);
    }

    .logo_div {
        position: relative;
        top: 0;
        left: 0;
        transform: translateX(0);
        margin-top: .25rem;
        width: calc(100vw - 4rem);
    }

    .wx_logo {
        position: absolute;
        bottom: 3rem;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// src/components/minLogin/m_information.vue